/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/ban-ts-comment, @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any */
/* tslint:disable */
// @ts-nocheck
// What's with all the above disables?
//  this is what a legacy 7 year old codebase looks like.
import { DSBackdrop } from '@elliemae/ds-backdrop';
import { styled, withTheme } from '@elliemae/ds-system';
import { get } from 'lodash-es';
import React, { useEffect, useRef, useState } from 'react';

const LoadingPageLoader = styled.div`
  ${({ type }) => (type === 'cover' ? 'position: fixed' : 'position: absolute')};

  z-index: ${(props) => props.zIndex || props.theme.zIndex.loader};
  top: 25%;
  left: 15%;
  width: 70%;
  height: 75%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const LoadingPage = ({ backdropZIndex, children, loader, loading, type = 'fill', zIndex }) => {
  const [position, setPosition] = useState(null);
  const childRef = useRef(null);
  useEffect(() => {
    if (childRef && childRef.current) {
      const style = childRef && window.getComputedStyle(childRef.current);
      setPosition(style.getPropertyValue('position'));
    }
  }, [childRef]);

  const Back = loading && <DSBackdrop type={type} zIndex={backdropZIndex} />;
  const Loader = loader && loading && (
    <LoadingPageLoader zIndex={zIndex} type={type} hide={!loading}>
      {loader}
    </LoadingPageLoader>
  );

  const injectRefPosition = (child) =>
    React.cloneElement(React.Children.only(child), {
      ref: childRef,
      children: React.Children.toArray(child.props.children).concat([Loader, Back]),
      style: {
        ...get(child, 'props.style', {}),
        position: position === 'static' ? 'relative' : position,
      },
    });

  if (React.Children.count(children) === 0) {
    return (
      <>
        {Loader}
        {Back}
      </>
    );
  }
  return injectRefPosition(children);
};

const DSMobileLoadingPage = withTheme(LoadingPage);

export { DSMobileLoadingPage };
